module.exports = __webpack_public_path__ + "media/video/videoFullService-a7d33063.png";